import React, { useState, useEffect } from 'react';

const ThemeToggle = () => {
    const [isDark, setIsDark] = useState(false);

    useEffect(() => {
        // Verificar se há preferência salva
        const savedTheme = localStorage.getItem('theme');
        const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
        
        if (savedTheme) {
            setIsDark(savedTheme === 'dark');
            document.documentElement.setAttribute('data-theme', savedTheme);
        } else if (prefersDark) {
            setIsDark(true);
            document.documentElement.setAttribute('data-theme', 'dark');
        }
    }, []);

    const toggleTheme = () => {
        const newTheme = isDark ? 'light' : 'dark';
        setIsDark(!isDark);
        document.documentElement.setAttribute('data-theme', newTheme);
        localStorage.setItem('theme', newTheme);
    };

    return (
        <button 
            className={`
                flex items-center gap-2 px-4 py-2 rounded-xl font-semibold text-sm
                transition-all duration-300 transform hover:scale-105 active:scale-95
                ${isDark 
                    ? 'bg-gradient-to-r from-yellow-400 to-orange-500 text-white shadow-lg hover:shadow-xl' 
                    : 'bg-gradient-to-r from-primary-600 to-primary-800 text-white shadow-lg hover:shadow-xl'
                }
                focus:outline-none focus:ring-2 focus:ring-accent-500 focus:ring-offset-2
                border-2 border-transparent hover:border-accent-400
            `}
            onClick={toggleTheme}
            aria-label={`Alternar para modo ${isDark ? 'claro' : 'escuro'}`}
        >
            <div className="w-5 h-5 transition-transform duration-300 hover:scale-110">
                {isDark ? (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="drop-shadow-sm">
                        <circle cx="12" cy="12" r="5"/>
                        <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/>
                    </svg>
                ) : (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="drop-shadow-sm">
                        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
                    </svg>
                )}
            </div>
            <span className="hidden sm:inline text-sm font-semibold tracking-wide">
                {isDark ? 'Claro' : 'Escuro'}
            </span>
        </button>
    );
};

export default ThemeToggle; 